import { render } from "./VendorPicker.vue?vue&type=template&id=ea3a69f0"
import script from "./VendorPicker.vue?vue&type=script&lang=js"
export * from "./VendorPicker.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__